// @flow
import React from 'react';

import { ProductFeaturesSlider } from 'Components/widgets/product-features-slider/ProductFeaturesSlider.jsx';
import { ProductInformation } from 'Components/widgets/product-information/ProductInformation.jsx';

import { type ProductFeatureCardProps } from 'Components/widgets/product-feature-card/ProductFeatureCard.jsx';
import { type IntroductionProps } from 'Components/frameworks/introduction/Introduction.jsx';

export type ProductFeaturesCategoryProps = {
  activities: Array<ProductFeatureCardProps>,
  backNavigationLabel?: string,
  errorMessage?: string,
  id: string,
  title: string,
};

type ProductFeaturesProps = {
  categories: Array<ProductFeaturesCategoryProps>,
  introduction?: IntroductionProps,
  labelGAPrefix: string,
  queryLayer: string,
  renderDetail: (data: *) => Node,
  scrollBackwardLabel?: string,
  scrollForwardLabel?: string,
};

function getItems({
  categories,
  labelGAPrefix,
  queryLayer,
  renderDetail,
  scrollBackwardLabel,
  scrollForwardLabel,
}) {
  return (categories || []).map((category, index) => ({
    header: {
      title: category.title,
      trackingData: {
        categoryGA: 'resort',
        actionGA: 'blockInfos',
        labelGA: `${labelGAPrefix}_${category.id}`,
      },
    },
    content: [
      <ProductFeaturesSlider
        backNavigationLabel={category.backNavigationLabel}
        errorMessage={category.errorMessage}
        items={category.activities}
        key={category.id}
        queryLayer={queryLayer}
        renderDetail={renderDetail}
        scrollBackwardLabel={scrollBackwardLabel}
        scrollForwardLabel={scrollForwardLabel}
        sliderIndex={index}
      />,
    ],
  }));
}

export function ProductFeatures({
  categories,
  introduction,
  labelGAPrefix,
  queryLayer = 'productActivitiesLayer',
  renderDetail,
  scrollBackwardLabel,
  scrollForwardLabel,
}: ProductFeaturesProps) {
  return (
    <ProductInformation
      introduction={introduction}
      items={getItems({
        categories,
        labelGAPrefix,
        queryLayer,
        renderDetail,
        scrollBackwardLabel,
        scrollForwardLabel,
      })}
      scrollBackwardLabel={scrollBackwardLabel}
      scrollForwardLabel={scrollForwardLabel}
    />
  );
}
